// /* eslint-disable no-unused-vars */
// import { useNavigate, useLocation } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchPermissions } from "../redux/slices/branch/permissionManagerSlice";
// import "../assets/css/sidebar.css";
// import { FaFileAlt, FaIdCard, FaUser } from "react-icons/fa";

// export default function Sidebar() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();

//   const [openSubMenu, setOpenSubMenu] = useState(null);
//   const [isExpanded, setIsExpanded] = useState(window.innerWidth > 768);
//   const [clickedIndex, setClickedIndex] = useState(null);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   const { data: userPermissions = [], loading } = useSelector(
//     (state) => state.permissionManager
//   );

//   const storedUserId = localStorage.getItem("userId");
//   const userId = storedUserId ? parseInt(storedUserId, 10) : 10;

//   useEffect(() => {
//     if (userId) dispatch(fetchPermissions(userId));
//   }, [dispatch, userId]);

//   // ✅ Window resize logic (mobile vs desktop)
//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth <= 768;
//       setIsMobile(mobile);
//       setIsExpanded(!mobile); // desktop = open, mobile = closed
//     };
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const isActive = (path) => location.pathname === path;

//   // ✅ Toggle sidebar only in mobile
//   const handleSidebarToggle = () => {
//     if (isMobile) setIsExpanded((prev) => !prev);
//   };

//   const handleMainClick = (item, index) => {
//     setClickedIndex(index);
//     if (item.subItems) {
//       setOpenSubMenu(openSubMenu === index ? null : index);
//     } else if (item.path) {
//       navigate(item.path);
//       if (isMobile) setIsExpanded(false);
//     }
//   };

//   const hasPermission = (perm) => !perm || userPermissions.includes(perm);

//   const menuItems = [
//     { icon: "fa fa-home", text: "Dashboard", path: "/dashboard", permission: null },
//     {
//       icon: "fa fa-users",
//       text: "Customer",
//       subItems: [
//         { text: "Create Customer", path: "/Customers/add", icon: "fa fa-user-plus", permission: "Create Customer" },
//         { text: "KYC", path: "/Customers/kyc", icon: "fa fa-id-card", permission: "Customer Kyc" },
//         { text: "Customer Report", path: "/CustomerReport", icon: "fa fa-book", permission: "Customer Report" },

//         { text: "Nominee", path: "/NomineeManagement", icon: "fa fa-book", permission: "Customer Report" },
//       ],
//     },
//     {
//       icon: "fa fa-user",
//       text: "HR Module",
//       subItems: [
//         { text: "Attendance", path: "/EmployeeAttendance", icon: "fa fa-calendar-check", permission: "Attendance" },
//         { text: "Apply Leave", path: "/LeaveForm", icon: "fa fa-clipboard-check", permission: "Leave Management" },
//         { text: "Holiday", path: "/Holiday", icon: "fa fa-calendar-alt", permission: "Payroll" },
//       ],
//     },
//     {
//       icon: "fa fa-hand-holding-usd",
//       text: "Loan",
//       subItems: [
//         { text: "Loan Applications", path: "/Loan/PersonalLoanForm", icon: "fa fa-file-signature", permission: "Loan Applications" },
//                 { text: "Loan Documents", path: "/Loan/LoanDocuments", icon: "fa fa-check-circle", permission: "Approvals" },

//         { text: "Loan Report", path: "/Loan/LoanReport", icon: "fa fa-check-circle", permission: "Loan Applications" },
//         { text: "EMI Calculator", path: "/Loan/EmiCalculator", icon: "fa fa-calculator", permission: "Loan Applications" },
//       ],
//     },
//     {
//       icon: "fa fa-university",
//       text: "Loan Kyc",
//       subItems: [
//         { text: "Loan KYC", path: "/Loan/LoanKyc", icon: "fa fa-id-card", permission: "Account Management" },
//       ],
//     },
//     // {
//     //   icon: "fa fa-hand-holding-usd",
//     //   text: "Emi Records",
//     //   subItems: [
//     //     { text: "Today Emi", path: "/Loan/EmiCalculator", icon: "fa fa-calculator", permission: "Loan Applications" },
//     //     { text: "Due Emi", path: "/Loan/PersonalLoanForm", icon: "fa fa-file-signature", permission: "Loan Applications" },
//     //     { text: "Paid Emi", path: "/Loan/LoanReport", icon: "fa fa-check-circle", permission: "Loan Applications" },
//     //   ],
//     // },
//     {
//       icon: "fa fa-university",
//       text: "Banking",
//       subItems: [
//         {
//           subItems: [
//             { text: "Saving Account", path: "/Banking/OpenAccount/Saving", permission: "Group Center", icon: "fa fa-bank" },
//              { text: "RD Account", path: "/Banking/OpenAccount/RDACC", permission: "Group Center", icon: "fa fa-bank" },

//                          { text: "FD Account", path: "/Banking/DepositAccount/FD", permission: "Group Center", icon: "fa fa-calendar" },

//                           { text: "FD/MIS Report", path: "/Banking/Report/DDReport", permission: "Group Center", icon: "fa fa-briefcase" },

//             // { text: "Current Account", path: "/Banking/OpenAccount/Current", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Sanction", path: "/Banking/OpenAccount/Sanction", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "CC Loan", path: "/Banking/OpenAccount/CC", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Apply  CC", path: "/Banking/OpenAccount/ApplyCC", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Promises  CC", path: "/Banking/OpenAccount/Promises", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Loan Agreement ", path: "/Banking/OpenAccount/Agreement", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "PaySlip ", path: "/Banking/OpenAccount/PaySlip", permission: "Group Center", icon: "fa fa-briefcase" },
//           ]
//         },
//         // {
//         //   text: "Deposit Accounts",
//         //   icon: "fa fa-folder-open",
//         //   subItems: [

//         //     { text: "DD Account", path: "/Banking/DepositAccount/DD", permission: "Group Center", icon: "fa fa-briefcase" },
//         //     { text: "RD  Account", path: "/Banking/DepositAccount/RD", permission: "Group Center", icon: "fa fa-briefcase" },
//         //     { text: "FD Account", path: "/Banking/DepositAccount/FD", permission: "Group Center", icon: "fa fa-calendar" },
//         //     { text: "MIS Account", path: "/Banking/DepositAccount/MIS", permission: "Group Center", icon: "fa fa-calendar" },
//         //   ]
//         // },
//         {

//           subItems: [
//             // { text: "Account Closure Report", path: "/Banking/Report/Close", permission: "Group Center", icon: "fa fa-briefcase" },
//             { text: "Saving Report", path: "/Banking/Report/Demo", permission: "Group Center", icon: "fa fa-briefcase" },
//              { text: "RD/DD Report", path: "/Banking/Report/RDReport", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Verify Report", path: "/Banking/Report/Verify", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "FD/RD DD/MIS Report", path: "/Banking/Report/DDReport", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "FD/MIS Report", path: "/Banking/Report/FDReport", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Deposite Bond certificate", path: "/Banking/Report/Bond", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Log", path: "/Banking/Report/Log", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "RD Certificate", path: "/Banking/Report/RDCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "FD Certificate", path: "/Banking/Report/FDCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
//             // // { text: "DD Certificate", path: "/Banking/Report/DDCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Mis Certificate", path: "/Banking/Report/MisCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "MemberShip Form", path: "/Banking/Report/Membership", permission: "Group Center", icon: "fa fa-briefcase" },
//             // { text: "Customer Certificate", path: "/Banking/Report/CustomerCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
//             //  { text: "Share Certificate", path: "/Banking/Report/SharesCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
//             //  { text: "Saving Passbook", path: "/Banking/Report/SavingPassbook", permission: "Group Center", icon: "fa fa-briefcase" },
// { text: "RD/DD due Report", path: "/Banking/Report/DepositInstallmentDueReport", permission: "Group Center", icon: "fa fa-briefcase" },
// { text: "Deposit Collection", path: "/Banking/depositcollection", permission: "Group Center", icon: "fa fa-wallet" },

//             ]
//         },
//         // {
//         //   text: "Scheme",i
//         //   icon: "fa fa-folder-open",
//         //   subItems: [
//         //     { text: "RD/DD Scheme", path: "/Banking/Scheme/RDScheme", permission: "Group Center", icon: "fa fa-calendar" },
//         //     { text: "FD/MIS Scheme", path: "/Banking/Scheme/FDScheme", permission: "Group Center", icon: "fa fa-calendar" },
//         //     { text: "Saving Scheme", path: "/Banking/Scheme/SavingScheme", permission: "Group Center", icon: "fa fa-calendar" },
//         //     { text: "Share Certificate", path: "/Banking/Scheme/Share", permission: "Group Center", icon: "fa fa-briefcase" },
//         //     { text: "MIS Payment", path: "/Banking/Scheme/MISPayment", permission: "Group Center", icon: "fa fa-briefcase" },
//         //     { text: "New CC", path: "/Banking/Scheme/NewCC", permission: "Group Center", icon: "fa fa-briefcase" },
//         //     { text: "News CC", path: "/Banking/Scheme/NewsCC", permission: "Group Center", icon: "fa fa-briefcase" },
//         //   ]
//         // }
//       ]
//     },

//     // Accounting
//     {
//   icon: "fa fa-user",
//   text: "Accountant",
//   subItems: [
//         { text: "Group List", path: "/GroupList", icon: "fa fa-id-card" },
//         { text: "Ledger List", path: "/LedgerList", icon: "fa fa-file-alt" },
//         { text: "Branch Ledger List", path: "/BranchLedgerList", icon: "fa fa-file-alt" },
//         { text: "Fund Transfer", path: "/FundTransfer", icon: "fa fa-exchange-alt" },
//         { text: "Overview", path: "/Overview", icon: "fa fa-chart-line" },
//         { text: "Profit Loss", path: "/ProfitLoss", icon: "fa fa-chart-bar" },

//     {
//       text: "Voucher",
//       icon: "fa fa-receipt",
//       subItems: [
//         { text: "Day Book", path: "/DayBook", icon: "fa fa-book" },
//         { text: "Cash Book", path: "/CashBook", icon: "fa fa-wallet" },
//         { text: "Voucher Entries", path: "/VoucherEntries", icon: "fa fa-file-invoice" },
//         { text: "Payment", path: "/Payment", icon: "fa fa-money-bill" },
//         { text: "Trial Balance", path: "/TrialBalance", icon: "fa fa-balance-scale" },
//         { text: "FY Trial Balance", path: "/FyTrialBalance", icon: "fa fa-chart-pie" },
//         { text: "FY Opening Balance", path: "/FyOpeningBalance", icon: "fa fa-door-open" },
//       ]
//     }
//   ]
// },

//     {
//       icon: "fa-solid fa-right-left",
//       text: "Transaction",
//       subItems: [
//         { text: "Transaction Form", path: "/transactions/TransactionForm", permission: "Group Center", icon: "fa-solid fa-money-bill-wave" },
//          ],
//     },
//     {
//       icon: "fa-solid fa-print",
//       text: "Print",
//       subItems: [
//         { text: "Print Statement", path: "/print/PrintStatement", permission: "Group Center", icon: "fa-solid fa-print" },
//          ],
//     },

//        {
//       icon: "fa fa-hand-holding-usd",
//       text: " Loan Reports",
//       subItems: [
//         { text: "EMI Due Report", path: "/Loan/EmiDueReport", icon: "fa fa-file-signature", permission: "Loan Applications" },
//         { text: "Collection Report", path: "/Loan/CollectionReport", icon: "fa fa-check-circle", permission: "Approvals" },
//         // { text: "Loan Closure Request", path: "/Loan/LoanClosureRequest", icon: "fa fa-check-circle", permission: "Approvals" },

//       ],
//     },
//     {
//       icon: "fa fa-users-cog",
//       text: "Group Loan",
//       subItems: [
//         { text: "Center Create", path: "/GroupLoan/GroupCenter", permission: "Group Center", icon: "fa fa-users" },
//         { text: "Loan Status", path: "/GroupLoan/GroupLoanStatus", permission: "Group Loan Status", icon: "fa fa-tasks" },
//         { text: "Emi Due Report", path: "/GroupLoan/EmiDueReportGroup", permission: "Emi Due Report Group", icon: "fa fa-file-invoice" },
//         { text: "Emi Due Member Report", path: "/GroupLoan/EmiDueReportMember", permission: "Emi Due Report Member", icon: "fa fa-user-check" },
//         { text: "Create Group", path: "/GroupLoan/GroupCreate", permission: "Group Create", icon: "fa fa-plus-circle" },
//         { text: "Loan Report", path: "/GroupLoan/GroupLoanReport", permission: "Group Loan Report", icon: "fa fa-chart-bar" },
//         { text: "Loan Scheme", path: "/GroupLoan/GroupLoanScheme", permission: "Group Loan Scheme", icon: "fa fa-cogs" },
//         { text: "Groups", path: "/GroupLoan/Groups", permission: "Group Center", icon: "fa fa-cogs" },
//         { text: "Area Survay", path: "/GroupLoan/Area", permission: "Group Center", icon: "fa fa-map"  },
//         { text: "Area Survay Report", path: "/GroupLoan/AreaSurvayReport", permission: "Group Center", icon: "fa fa-map"  },
//         { text: "Group CGT ", path: "/GroupLoan/Cgt", permission: "Group Center", icon: "fa fa-users" },
//         { text: "Group GRT ", path: "/GroupLoan/Grt", permission: "Group Center", icon: "fa fa-users"  },
//         { text: "CGT Training", path: "/GroupLoan/CgtTraining", permission: "Group Center", icon: "fa fa-graduation-cap" },
//         { text: "GRT Training", path: "/GroupLoan/GrtTraining", permission: "Group Center", icon: "fa fa-graduation-cap" },
//         { text: "Group Loan Form", path: "/GroupLoan/GroupLoanForm", permission: "Group Center", icon: "fa fa-money-bill" },
//       ],
//     },
//     {
//       icon: "fa-solid fa-file-circle-check",
//       text: "Cibil",
//       subItems: [
//         { text: "Cibil Check", path: "/Cibil/Cibil", permission: "Group Center", icon: "fa-solid fa-circle-check" },
//         { text: "Cibil Report", path: "/Cibil/CibilReport", permission: "Group Center", icon: "fa-double fa-circle-check" },
//          ],
//     },
//     // { icon: "fa fa-envelope", text: "Contact Us", path: "/Contact", permission: null },

//   ];

//   if (loading) return <div className="sidebar-loading">Loading menu...</div>;

//   // 🔹 Recursive submenu renderer
//   const renderSubMenu = (items) =>
//     items
//       .filter(sub => hasPermission(sub.permission))
//       .map((sub, idx) => (
//         <div key={idx} className="submenu-wrapper">
//           <button
//             className={`submenu-item ${isActive(sub.path) ? "active" : ""}`}
//             onClick={() => sub.path && navigate(sub.path)}
//           >
//             <i className={`${sub.icon} icon`} />
//             <span>{sub.text}</span>
//             {sub.subItems && <i className={``} />}
//           </button>
//           {sub.subItems && <div className="submenu">{renderSubMenu(sub.subItems)}</div>}
//         </div>
//       ));

//   return (
//     <>
//       {/* 3-Line Toggle button — show only on mobile */}
//       {isMobile && (
//         <div
//           className="floating-toggle"
//           onClick={handleSidebarToggle}
//           aria-label="Toggle Sidebar"
//         >
//           <span></span>
//           <span></span>
//           <span></span>
//         </div>
//       )}

//       <div className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
//         <div className="menu-list">
//           {menuItems
//             .filter(item => item.subItems ? item.subItems.some(sub => hasPermission(sub.permission)) : hasPermission(item.permission))
//             .map((item, index) => {
//               const isSubMenuOpen = openSubMenu === index;
//               return (
//                 <div key={index} className="menu-item">
//                   <button
//                     className={`main-item ${clickedIndex === index ? "clicked" : ""}`}
//                     onClick={() => handleMainClick(item, index)}
//                   >
//                     <i className={`${item.icon} icon`} />
//                     <span className="label">{item.text}</span>
//                     {item.subItems && <i className={`fa fa-chevron-right arrow ${isSubMenuOpen ? "rotated" : ""}`} />}
//                   </button>

//                   {item.subItems && isSubMenuOpen && (
//                     <div className="submenu">
//                       {renderSubMenu(item.subItems)}
//                     </div>
//                   )}
//                 </div>
//               );
//             })}
//         </div>
//       </div>
//     </>
//   );
// }

/* eslint-disable no-unused-vars */
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchPermissions } from "../redux/slices/branch/permissionManagerSlice";
import "../assets/css/sidebar.css";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [openMenu, setOpenMenu] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const [isExpanded, setIsExpanded] = useState(window.innerWidth > 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const { data: userPermissions = [], loading } = useSelector(
    (state) => state.permissionManager,
  );

  const storedUserId = localStorage.getItem("userId");
  const userId = storedUserId ? parseInt(storedUserId, 10) : null;

  useEffect(() => {
    if (userId) dispatch(fetchPermissions(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsExpanded(!mobile);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto open menu on route change
  useEffect(() => {
    menuItems.forEach((menu, mIndex) => {
      if (!menu.subItems) return;

      menu.subItems.forEach((sub, sIndex) => {
        if (sub.path === location.pathname) {
          setOpenMenu(mIndex);
          setOpenSubMenu(`m-${mIndex}-${sIndex}`);
        }

        if (sub.subItems) {
          sub.subItems.forEach((nested) => {
            if (nested.path === location.pathname) {
              setOpenMenu(mIndex);
              setOpenSubMenu(`m-${mIndex}-${sIndex}`);
            }
          });
        }
      });
    });
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const hasPermission = (perm) => !perm || userPermissions.includes(perm);

  const handleMainClick = (index, hasSub, path) => {
    if (hasSub) {
      setOpenMenu((prev) => (prev === index ? null : index));
      setOpenSubMenu(null);
    } else if (path) {
      navigate(path);
      if (isMobile) setIsExpanded(false);
      setOpenMenu(null);
      setOpenSubMenu(null);
    }
  };

  const toggleSubMenu = (key) => {
    setOpenSubMenu((prev) => (prev === key ? null : key));
  };

  //============================================
  //   MENU LIST (icons added for nested too)
  //============================================
  const menuItems = [
    {
      icon: "fa fa-home",
      text: "Dashboard",
      path: "/dashboard",
      permission: null,
    },
    // {
    //   icon: "fa fa-home",
    //   text: "Agent Dashboard",
    //   path: "/AgentDashboard",
    //   permission: null,
    // },

    // Customer
    {
      icon: "fa fa-users",
      text: "Customer",
      subItems: [
        {
          text: "Create Customer",
          path: "/Customers/add",
          icon: "fa-solid fa-plus",
          permission: "Create Customer",
        },
        {
          text: "Search Customer",
          path: "/Customers/SearchCustomer",
          icon: "fa-solid fa-magnifying-glass",
          permission: "Search Customer",
        },
        {
          text: "Upload KYC",
          path: "/Customers/kyc",
          icon: "fa-solid fa-cloud-arrow-up",
          permission: "Customer Kyc",
        },
        {
          text: "Customer Report",
          path: "/CustomerReport",
          icon: "fa-regular fa-file-lines",
          permission: "Customer Report",
        },
        {
          text: "Nominee",
          path: "/NomineeManagement",
          icon: "fa fa-book",
          permission: "Nominee",
        },
      ],
    },

    // HR Module
    {
      icon: "fa-solid fa-users-gear",
      text: "HR Module",
      subItems: [
        {
          text: "Employee Attendance",
          path: "/EmployeeAttendance",
          icon: "fa-solid fa-user-check",
          permission: "Employee Attendance",
        },
        {
          text: "Apply Leave",
          path: "/LeaveForm",
          icon: "fa-solid fa-right-from-bracket",
          permission: "Apply Leave",
        },
        {
          text: "Holiday List",
          path: "/Holiday",
          icon: "fa-solid fa-list",
          permission: "Holiday List",
        },
      ],
    },

    // Loan
    {
      icon: "fa-solid fa-hand-holding-dollar",
      text: "Loans",
      subItems: [
        {
          text: "Apply Loan",
          path: "/Loan/PersonalLoanForm",
          icon: "fa-solid fa-file-signature",
          permission: "Apply Loan",
        },
        {
          text: "Apply Fixed Loan",
          path: "/Loan/FixedLoanForm",
          icon: "fa-solid fa-file-signature",
          permission: "Apply Loan",
        },
        {
          text: "Upload Loan KYC",
          path: "/Loan/LoanKyc",
          icon: "fa-solid fa-cloud-arrow-up",
          permission: "Upload Loan Kyc",
        },
        {
          text: "Loan Report",
          path: "/Loan/LoanReport",
          icon: "fa-solid fa-chart-line",
          permission: "Loan Report",
        },
        {
          text: "Loan Statement",
          path: "/Loan/LoanStatement",
          icon: "fa-solid fa-file-invoice-dollar",
          permission: "Loan Statement",
        },
        {
          text: "Single Loan Emi Pay",
          path: "/Loan/SingleLoanEmiPay",
          icon: "fa-solid fa-building-columns",
          permission:"Single Loan Emi Pay",
        },
        {
          text: "EMI Due Report",
          path: "/Loan/EmiDueReport",
          icon: "fa-solid fa-file-invoice-dollar",
          permission: "Emi Due Report",
        },
        {
          text: "Collection Report",
          path: "/Loan/CollectionReport",
          icon: "fa-solid fa-coins",
          permission: "Collection Report",
        },
        {
          text: "Loan Closer Request",
          path: "/Loan/LoanCloserRequest",
          icon: "fa-solid fa-file-circle-xmark",
          permission: "Loan Closer Request",
        },
        
        {
          text: "Loan Closer Report",
          path: "/Loan/LoanCloserReport",
          icon: "fa-solid fa-file-circle-check",
          permission: "Loan Closer Request",
        },
        {
          text: "Loan Settlement",
          path: "/Loan/LoanSettlement",
          icon: "fa-solid fa-file-circle-xmark",
          permission: "Loan Settlement",
        },
        // {
        //   text: "Loan Pre Closer Request",
        //   path: "/Loan/LoanPreCloserRequest",
        //   icon: "fa-solid fa-file-circle-xmark",
        //   permission: "Loan Pre Closer Request",
        // },
        {
          text: "Loan Documents",
          path: "/Loan/LoanDocuments",
          icon: "fa-solid fa-folder-open",
          permission: "Loan Documents",
        },
        // {
        //   text: "EMI Calculator",
        //   path: "/Loan/EmiCalculator",
        //   icon: "fa-solid fa-calculator",
        //   permission: "Loan Applications",
        // },
      ],
    },

    // Loan Kyc
    // {
    //   icon: "fa fa-university",
    //   text: "Loan Kyc",
    //   subItems: [
    //     {
    //       text: "Loan KYC",
    //       path: "/Loan/LoanKyc",
    //       icon: "fa fa-id-card",
    //       permission: "Account Management",
    //     },
    //   ],
    // },

    // {
    //   icon: "fa fa-hand-holding-usd",
    //   text: "Emi Records",
    //   subItems: [
    //     { text: "Today Emi", path: "/Loan/EmiCalculator", icon: "fa fa-calculator", permission: "Loan Applications" },
    //     { text: "Due Emi", path: "/Loan/PersonalLoanForm", icon: "fa fa-file-signature", permission: "Loan Applications" },
    //     { text: "Paid Emi", path: "/Loan/LoanReport", icon: "fa fa-check-circle", permission: "Loan Applications" },
    //   ],
    // },

    // Banking (hiding in aayogfin at building time)
    {
      icon: "fa-solid fa-building-columns",
      text: "Banking",
      subItems: [
        {
          icon: "fa-solid fa-folder-plus",
          text: "Account Opening",
          subItems: [
            {
              text: "Saving Account",
              path: "/Banking/OpenAccount/Saving",
              permission: "Saving Account",
              icon: "fa-solid fa-piggy-bank",
            },
            {
              text: "RD/DD Account",
              path: "/Banking/OpenAccount/RDACC",
              permission: "RD/DD Account",
              icon: "fa-solid fa-file-contract",
            },
            {
              text: "FD/MIS Account",
              path: "/Banking/DepositAccount/FD",
              permission: "FD/MIS Account",
              icon: "fa-solid fa-vault",
            },
          ],
        },
        {
          text: "Verify Account",
          path: "/Banking/VerifyAccount",
          permission: "Verify Account",
          icon: "fa-solid fa-user-check",
        },

        {
          icon: "fa-solid fa-chart-pie",
          text: "Reports",
          subItems: [
            // { text: "Account Closure Report", path: "/Banking/Report/Close", permission: "Group Center", icon: "fa fa-briefcase" },
            {
              text: "Saving Report",
              path: "/Banking/Report/Demo",
              permission: "Saving Report",
              icon: "fa-solid fa-piggy-bank",
            },
            {
              text: "Saving Closer Report",
              path: "/Banking/Report/SavingCloserRequest",
              permission: "Saving Closer Report",
              icon: "fa-solid fa-piggy-bank",
            },
            {
              text: "RD/DD Report",
              path: "/Banking/Report/RDReport",
              permission: "RD/DD Report",
              icon: "fa-solid fa-file-invoice",
            },
            // {
            //   text: "RD/DD Closer Report",
            //   path: "/Banking/Report/RDDDCloserRequest",
            //   permission: "Group Center",
            //   icon: "fa-solid fa-file-invoice",
            // },
            {
              text: "FD/MIS Report",
              path: "/Banking/Report/DDReport",
              permission: "FD/MIS Report",
              icon: "fa-solid fa-vault",
            },
            // {
            //   text: "FD/MIS Closer Report",
            //   path: "/Banking/Report/FDMISCloserRequest",
            //   permission: "Group Center",
            //   icon: "fa-solid fa-vault",
            // },
            // { text: "Verify Report", path: "/Banking/Report/Verify", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "FD/RD DD/MIS Report", path: "/Banking/Report/DDReport", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "FD/MIS Report", path: "/Banking/Report/FDReport", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "Deposite Bond certificate", path: "/Banking/Report/Bond", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "Log", path: "/Banking/Report/Log", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "RD Certificate", path: "/Banking/Report/RDCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "FD Certificate", path: "/Banking/Report/FDCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
            // // { text: "DD Certificate", path: "/Banking/Report/DDCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "Mis Certificate", path: "/Banking/Report/MisCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "MemberShip Form", path: "/Banking/Report/Membership", permission: "Group Center", icon: "fa fa-briefcase" },
            // { text: "Customer Certificate", path: "/Banking/Report/CustomerCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
            //  { text: "Share Certificate", path: "/Banking/Report/SharesCertificates", permission: "Group Center", icon: "fa fa-briefcase" },
            //  { text: "Saving Passbook", path: "/Banking/Report/SavingPassbook", permission: "Group Center", icon: "fa fa-briefcase" },
            {
              text: "RD/DD due Report",
              path: "/Banking/Report/DepositInstallmentDueReport",
              permission: "RD/DD due Report",
              icon: "fa-solid fa-clock-rotate-left",
            },
            {
              text: "Deposit Collection",
              path: "/Banking/depositcollection",
              permission: "Deposite Collection",
              icon: "fa-solid fa-wallet",
            },
          ],
        },
        {
          text: "Close Account",
          path: "/CloseAccount",
          permission: "Close Accoun",
          icon: "fa-solid fa-user-slash",
        },
      ],
    },

    // Accounting
    {
      icon: "fa-solid fa-user-tie",
      text: "Accountant",
      subItems: [
        // { text: "Group List", path: "/Accountant/GroupList", icon: "fa fa-id-card" },
        // { text: "Ledger List", path: "/Accountant/LedgerList", icon: "fa fa-file-alt" },
        // { text: "Branch Ledger List", path: "/Accountant/BranchLedgerList", icon: "fa fa-file-alt" },
        {
          text: "Ledger Entry",
          path: "/Accountant/LedgerEntry",
          icon: "fa-solid fa-book",
          permission:"Ledger Entry"
        },
        {
          text: "Fund Transfer",
          path: "/Accountant/FundTransfer",
          icon: "fa-solid fa-right-left",
          permission:"Fund Transfer"
        },
        {
          text: "Overview",
          path: "/Accountant/Overview",
          icon: "fa-solid fa-chart-simple",
          permission:"Overview"
        },
        {
          text: "Profit Loss",
          path: "/Accountant/ProfitLoss",
          icon: "fa-solid fa-arrow-trend-down",
          permission:"Profit Loss"
        },

        {
          text: "Voucher",
          icon: "fa-solid fa-receipt",
          subItems: [
            {
              text: "Day Book",
              path: "/Accountant/Voucher/DayBook",
              icon: "fa-solid fa-book-open",
              permission:"Day Book"
            },
            {
              text: "Cash Book",
              path: "/Accountant/Voucher/CashBook",
              icon: "fa-solid fa-money-bill",
              permission:"Cash Book"
            },
            {
              text: "Voucher Entries",
              path: "/Accountant/Voucher/VoucherEntries",
              icon: "fa-solid fa-file-invoice",
              permission:"Voucher Entries"
            },
            {
              text: "Payment",
              path: "/Accountant/Voucher/Payment",
              icon: "fa-solid fa-credit-card",
              permission:"Payment"
            },
            {
              text: "Journal",
              path: "/Accountant/Voucher/Journal",
              icon: "fa-solid fa-book",
              permission:"Journal"
            },

            {
              text: "Trial Balance",
              path: "/Accountant/Voucher/TrialBalance",
              icon: "fa-solid fa-scale-balanced",
              permission:"Trial Balance"
            },
            {
              text: "FY Trial Balance",
              path: "/Accountant/Voucher/FyTrialBalance",
              icon: "fa-solid fa-chart-pie",
              permission:"Fy Trial Balance"
            },
            {
              text: "FY Opening Balance",
              path: "/Accountant/Voucher/FyOpeningBalance",
              icon: "fa-solid fa-building-columns",
              permission:"Fy Opening Balance"
            },
          ],
        },
      ],
    },

    // Transaction  (hiding in aayogfin at building time)
    {
      icon: "fa-solid fa-arrow-right-arrow-left",
      text: "Transaction",
      subItems: [
        //     {
        //       text: "Pay Installment",
        //       path: "/transactions/PayInstallment",
        //       permission: "Group Center",
        //       icon: "fa-solid fa-hand-holding-dollar",
        //     },
        {
          text: "Saving Account Transaction",
          path: "/transactions/SavingAccountTransaction",
          permission: "Saving Account Transaction",
          icon: "fa-solid fa-building-columns",
        },
        {
          text: "RD/DD Account Transaction",
          path: "/transactions/RDDDAccountTransaction",
          icon: "fa-solid fa-building-columns",
          permission:"RD/DD Account Transaction"
        },
        {
          text: "RD/DD Pre Closure",
          path: "/transactions/RDDDPreClosure",
          icon: "fa-solid fa-building-columns",
          permission:"RD/DD Pre Closure",
        },
        {
          text: "RD/DD Single Emi Pay",
          path: "/transactions/RDDDEmiPay",
          icon: "fa-solid fa-building-columns",
          permission:"RD/DD Single Emi Pay",
        },
        //     {
        //       text: "Approve Saving Transaction",
        //       path: "/transactions/ApproveSavingTransaction",
        //       permission: "Group Center",
        //       icon: "fa-solid fa-circle-check",
        //     },
        {
          text: "Transaction Report",
          path: "/transactions/TransactionReport",
          permission: "Transaction Report",
          icon: "fa-solid fa-file-lines",
        },
        //     {
        //       text: "Collection Report",
        //       path: "/transactions/CollectionReport",
        //       permission: "Group Center",
        //       icon: "fa-solid fa-wallet",
        //     },
        //     {
        //       text: "Transaction Form",
        //       path: "/transactions/TransactionForm",
        //       permission: "Group Center",
        //       icon: "fa-solid fa-file-pen",
        //     },
      ],
    },

    // Wallet
    {
      text: "Wallet",
      icon: "fa-solid fa-wallet",
      subItems: [
        {
          text: "Request Wallet Fund",
          path: "/wallet/RequestWalletFund",
          permission: "Request Wallet Fund",
          icon: "fa-solid fa-hand-holding-dollar",
        },
        {
          text: "Wallet Transaction",
          path: "/wallet/WalletTransaction",
          permission: "Wallet Transaction",
          icon: "fa-solid fa-clock-rotate-left",
        },
      ],
    },

    // Print
    // {
    //   icon: "fa-solid fa-print",
    //   text: "Print",
    //   subItems: [
        // {
        //   text: "Deposit Bond Print",
        //   path: "/print/DepositBondPrint",
        //   permission: "Group Center",
        //   icon: "fa-solid fa-file-invoice",
        // },
        // {
        //   text: "Print Loan All Document",
        //   path: "/print/PrintLoanAllDocument",
        //   permission: "Group Center",
        //   icon: "fa-solid fa-folder-open",
        // },
        // {
        //   text: "Print Loan Statement",
        //   path: "/Print/LoanStatement",
        //   permission: "Group Center",
        //   icon: "fa-solid fa-folder-open",
        // },
        // {
        //   text: "Print Passbook",
        //   path: "/print/PrintPassbook",
        //   permission: "Group Center",
        //   icon: "fa-solid fa-book",
        // },
        // {
        //   text: "Account Statement",
        //   path: "/print/PrintStatement",
        //   permission: "Group Center",
        //   icon: "fa-solid fa-file-lines",
        // },
        // {
        //   text: "Print Statement",
        //   path: "/print/PrintStatement",
        //   permission: "Group Center",
        //   icon: "fa-solid fa-print",
        // },
    //   ],
    // },

    // Loan Reports
    // {
    //   icon: "fa fa-hand-holding-usd",
    //   text: " Loan Reports",
    //   subItems: [
    //     {
    //       text: "EMI Due Report",
    //       path: "/Loan/EmiDueReport",
    //       icon: "fa fa-file-signature",
    //       permission: "Loan Applications",
    //     },
    //     {
    //       text: "Collection Report",
    //       path: "/Loan/CollectionReport",
    //       icon: "fa fa-check-circle",
    //       permission: "Approvals",
    //     },
    //     // { text: "Loan Closure Request", path: "/Loan/LoanClosureRequest", icon: "fa fa-check-circle", permission: "Approvals" },
    //   ],
    // },

    // Group Loan
    {
      icon: "fa-solid fa-users-gear",
      text: "Group Loan",
      subItems: [
        // {
        //   text: "Center Create",
        //   path: "/GroupLoan/AreaSurveyCenter",
        //   permission: "Group Center",
        //   icon: "fa fa-users",
        // },
        {
          text: "Center Create",
          path: "/GroupLoan/CenterCreate",
          permission: "Center Create",
          icon: "fa fa-users",
        },
        // { text: "Loan Status", path: "/GroupLoan/GroupLoanStatus", permission: "Group Loan Status", icon: "fa fa-tasks" },
        // { text: "Emi Due Report", path: "/GroupLoan/EmiDueReportGroup", permission: "Emi Due Report Group", icon: "fa fa-file-invoice" },
        // { text: "Emi Due Member Report", path: "/GroupLoan/EmiDueReportMember", permission: "Emi Due Report Member", icon: "fa fa-user-check" },
        {
          text: "Create Group",
          path: "/GroupLoan/GroupCreate",
          permission: "Create Group",
          icon: "fa fa-plus-circle",
        },
        {
          text: "Group Loan Apply",
          path: "/GroupLoan/GroupLoanForm",
          permission: "Group Loan Apply",
          icon: "fa fa-money-bill",
        },
        {
          text: "Loan Report",
          path: "/GroupLoan/GroupLoanReport",
          permission: "Group Loan Report",
          icon: "fa fa-chart-bar",
        },
        {
          text: "Emi Due Report",
          path: "/GroupLoan/GroupLoanEmiDueReport",
          permission: "Emi Due Report Group",
          icon: "fa fa-file-invoice-dollar",
        },
        {
          text: "Collection Report",
          path: "/GroupLoan/GroupLoanCollectionReport",
          permission: "Group Collection Report",
          icon: "fa fa-hand-holding-usd",
        },
        {
          text: "Demand Sheet",
          path: "/GroupLoan/DemandSheet",
          permission: "Demand Sheet",
          icon: "fa fa-file-invoice-dollar",
        },

        // { text: "Loan Scheme", path: "/GroupLoan/GroupLoanScheme", permission: "Group Loan Scheme", icon: "fa fa-cogs" },
        // {
        //   text: "Groups",
        //   path: "/GroupLoan/Groups",
        //   permission: "Group Center",
        //   icon: "fa fa-cogs",
        // },
        {
          text: "Area Survay",
          path: "/GroupLoan/Area",
          permission: "Area Survay",
          icon: "fa fa-map",
        },
        {
          text: "Area Survay Report",
          path: "/GroupLoan/AreaSurvayReport",
          permission: "Area Suvay Report",
          icon: "fa fa-map",
        },
        { text: "Group CGT ", path: "/GroupLoan/Cgt", permission: "Group Center", icon: "fa fa-users" },
        { text: "Group GRT ", path: "/GroupLoan/Grt", permission: "Group Center", icon: "fa fa-users"  },
        // { text: "CGT Training", path: "/GroupLoan/CgtTraining", permission: "Group Center", icon: "fa fa-graduation-cap" },
        // { text: "GRT Training", path: "/GroupLoan/GrtTraining", permission: "Group Center", icon: "fa fa-graduation-cap" },
      ],
    },
    

     // Gold Loan
    {
      icon: "fa-solid fa-coins",
      text: "Gold Loan",

      subItems: [
        {
          text: "Gold Loan Apply",
          path: "/Goldloan/Goldloanform",
          permission: "Gold Loan Apply",
          icon: "fa fa-money-bill",
        },
        {
          text: "Gold Loan Report",
          path: "/GoldLoan/GoldLoanReport",
          permission: "Gold Loan Report",
          icon: "fa fa-chart-bar",
        },
        // {
        //   text: "Emi Due Report",
        //   path: "/Goldloan/GoldEmiDuereport",
        //   permission: "Group Loan Report",
        //   icon: "fa fa-file-invoice-dollar",
        // },
        {
          text: "Collection Report",
          path: "/Goldloan/GoldCollectionReport",
          permission: "Gold Loan Collection Report",
          icon: "fa fa-hand-holding-usd",
        },
        ],
    },

    // Vehicle Loan 
    {
      icon: "fa-solid fa-car",
      text: "Vehicle Loan",

      subItems: [
        {
          text: "Vehicle Loan Apply",
          path: "/vehicleloan/vehicleLoanForm",
          permission: "Vehicle Loan Apply",
          icon: "fa fa-money-bill",
        },
        {
          text: "Vehicle Loan Report",
          path: "/vehicleloan/vehicleLoanReport",
          permission: "Vehicle Loan Report",
          icon: "fa fa-chart-bar",
        },
        {
          text: "Emi Due Report",
          path: "/vehicleloan/vehicleEmiDueReport",
          permission: "Vehicle Loan Emi Due Report",
          icon: "fa fa-file-invoice-dollar",
        },
        {
          text: "Collection Report",
          path: "/vehicleloan/vehicleCollectionReport",
          permission: "Vehicle Loan Collection Report",
          icon: "fa fa-hand-holding-usd",
        },
        ],
    },

    // Product Loan 
    {
      icon: "fa-solid fa-cart-shopping",
      text: "Product Loan",
      subItems: [
        {
          text: "Product Loan Apply",
          path: "/Productloan/ProductLoanForm",
          permission: "Product Loan Apply",
          icon: "fa fa-money-bill",
        },
        {
          text: "Product Loan Report",
          path: "/Productloan/ProductLoanReport",
          permission: "Product Loan Report",
          icon: "fa fa-chart-bar",
        },
        {
          text: "Emi Due Report",
          path: "/Productloan/ProductLoanEmiDueReport",
          permission: "Product Loan Emi Due Report",
          icon: "fa fa-file-invoice-dollar",
        },
        {
          text: "Collection Report",
          path: "/Productloan/ProductCollectionReport",
          permission: "Product Loan Collection Report",
          icon: "fa fa-hand-holding-usd",
        },
        {
          text: "Product Loan Documents",
          path: "/Productloan/ProductLoanDocuments",
          permission: "Product Loan Collection Report",
          icon: "fa fa-hand-holding-usd",
        },
        ],
    },

    // Cibilcom
    {
      icon: "fa-solid fa-file-circle-check",
      text: "Cibil",
      subItems: [
        {
          text: "Cibil Check",
          path: "/Cibil/Cibil",
          permission: "Cibil Check",
          icon: "fa-regular fa-circle-check",
        },
        {
          text: "Cibil Report",
          path: "/Cibil/CibilReport",
          permission: "Cibil Report",
          icon: "fa-regular fa-file-lines",
        },
      ],
    },
    // { icon: "fa fa-envelope", text: "Contact Us", path: "/Contact", permission: null },
  ];

  //=========================================================
  // UPDATED SUBMENU (ICONS + nested arrow support 🔥)
  //=========================================================
  const renderSubMenu = (items, parentKey = "") =>
    items
      .filter((item) => hasPermission(item.permission))
      .map((item, idx) => {
        const key = `${parentKey}-${idx}`;
        const isOpen = openSubMenu === key;

        return (
          <div key={key} className="submenu-wrapper">
            <button
              className={`submenu-item ${isActive(item.path) ? "active" : ""}`}
              onClick={() =>
                item.subItems ? toggleSubMenu(key) : navigate(item.path)
              }
            >
              <i className={`${item.icon || "fa fa-circle"} sub-icon`} />
              <span>{item.text}</span>

              {item.subItems && (
                <i
                  className={`fa fa-chevron-right arrow ${
                    isOpen ? "rotated" : ""
                  }`}
                />
              )}
            </button>

            {item.subItems && isOpen && (
              <div className="submenu nested">
                {renderSubMenu(item.subItems, key)}
              </div>
            )}
          </div>
        );
      });

  if (loading) {
    return <div className="sidebar-loading">Loading menu...</div>;
  }

  return (
    <>
      {isMobile && (
        <div
          className="floating-toggle"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}

      <div className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
        <div className="menu-list">
          {menuItems.map((item, index) => {
            const isOpen = openMenu === index;

            if (!hasPermission(item.permission)) return null;

            return (
              <div key={index} className="menu-item">
                <button
                  className={`main-item ${isActive(item.path) ? "active" : ""}`}
                  onClick={() =>
                    handleMainClick(index, item.subItems, item.path)
                  }
                >
                  <i className={`${item.icon} icon`} />
                  <span>{item.text}</span>
                  {item.subItems && (
                    <i
                      className={`fa fa-chevron-right arrow ${
                        isOpen ? "rotated" : ""
                      }`}
                    />
                  )}
                </button>

                {item.subItems && isOpen && (
                  <div className="submenu">
                    {renderSubMenu(item.subItems, `m-${index}`)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
